<router-outlet></router-outlet>
@if (isLoggedIn) {
  <yokahu-chatbot (openClose)="onChatbotOpenClose($event)"></yokahu-chatbot>
}
@if (progressBar) {
  <div class="custom-loader-backdrop">
    <div class="spinner-rectangle-bounce">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
